// Reusable info icon (ⓘ) that shows a CustomTooltip on hover. Bundles the hand-rolled
// span+CustomTooltip pattern (there is no app-wide info-tooltip wrapper) so dashboard KPI tiles
// and chart titles can just pass `content`. Renders nothing when content is empty.
import React, { ReactNode, useId } from 'react';
import SvgInfo from '@icons/circle-info.svg?react';
import CustomTooltip from '@components/ringil3/Tooltip/CustomTooltip.tsx';

interface DashboardInfoTooltipProps {
  content: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

const DashboardInfoTooltip: React.FC<DashboardInfoTooltipProps> = ({ content, position = 'top', className }) => {
  // inline-flex so the tooltip anchors correctly to the icon (see CustomTooltip usage notes).
  const targetId = `db-tip-${useId().replace(/:/g, '')}`;
  if (!content) return null;
  return (
    <>
      <span id={targetId} className={`inline-flex items-center cursor-help text-content-tertiary ${className ?? ''}`}>
        <SvgInfo className="w-3 h-3" />
      </span>
      <CustomTooltip targetSelector={`#${targetId}`} content={content} position={position} />
    </>
  );
};

export default DashboardInfoTooltip;